import { ActionType, CompleteServicesStepPayload } from "../../../AppDataProvider/actions";
import { AppContext, BookingData } from "../../../AppDataProvider/AppDataProvider";
import React, { ReactElement, useContext, useEffect } from "react";
import { PartRequired } from "../../../utils/types";
import { requireBookingDataFields } from "../../../utils";
import { StepContent } from "../StepContent/StepContent";
type ServiceStepBookingData = PartRequired<BookingData, "organisation">;
export function ServiceData(): ReactElement {
  const {
    appData,
    appDataDispatch
  } = useContext(AppContext);
  const {
    bookingTool
  } = appData;
  const {
    forceServiceSelection
  } = bookingTool;
  requireBookingDataFields<ServiceStepBookingData>(appData.bookingData, ["organisation"]);
  const {
    organisation
  } = appData.bookingData;
  useEffect(() => {
    const services = {
      ...appData.bookingTool.services,
      edges: appData.bookingTool.services.edges.filter(({
        node
      }) => {
        return node.organisation?._id === organisation._id;
      })
    };

    /**
     * If there is only 1 service we need to use the id of that single service.
     * This will be required when the service selection step is disabled.
     *
     * Also, if the service only allows one attendee, or only has one duration,
     * we also need to add those values directly to the bookingData.
     */
    if (services.edges.length === 1 && !forceServiceSelection) {
      const service = services.edges[0].node;
      const payload: CompleteServicesStepPayload = {
        updatedData: {
          service
        }
      };
      appDataDispatch({
        payload,
        type: ActionType.COMPLETE_SERVICES_STEP
      });
    }

    /**
     * If we have been provided a serviceId in the url params,
     * we want to automatically select that service
     */
    const urlParams = new URLSearchParams(window.location.search);
    const preFillServiceId = urlParams.get("serviceId");
    if (services.edges.length > 0 && preFillServiceId) {
      const foundService = services.edges.find(({
        node
      }) => {
        return node._id === preFillServiceId;
      });
      if (foundService) {
        const payload: CompleteServicesStepPayload = {
          updatedData: {
            service: foundService.node
          }
        };
        appDataDispatch({
          payload,
          type: ActionType.COMPLETE_SERVICES_STEP
        });
      } else {
        console.error(`Service with ID ${preFillServiceId} not found.`);
      }
    }
  }, [appDataDispatch, appData.bookingTool.services, organisation._id, forceServiceSelection]);

  // We only want to display services for this organisation
  const services = {
    ...appData.bookingTool.services,
    edges: appData.bookingTool.services.edges.filter(({
      node
    }) => {
      return node.organisation?._id === organisation._id;
    })
  };
  return <StepContent services={services} data-sentry-element="StepContent" data-sentry-component="ServiceData" data-sentry-source-file="ServiceData.tsx" />;
}
export default ServiceData;